module.exports = __webpack_public_path__ + "static/media/img-ovato-mascot.d9671416.pdf";